/* eslint-disable */
import { endpoints } from '../Constants';
import { authHeader } from '../Helpers';
import handleResponse from './helpers';

const CHAT_FILE = endpoints.CHAT_FILE;

// On servers nginx adds clientId; a local backend (REACT_APP_SERVER_CHAT_URL) has no nginx.
const localHeaders = () => (endpoints.SERVER_CHAT.includes('localhost') ? { clientId: '0' } : {});

// One multiplexed endpoint on the DEV server: body.action = status | setup | setClaudeToken |
// list | get | ask | clear | getPage | refreshPage | deletePage | resetSummary | reset.
function chatAction(action, body) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
			...localHeaders(),
		},
		body: JSON.stringify({ action, ...(body || {}) }),
	};
	return fetch(endpoints.SERVER_CHAT, requestOptions).then(handleResponse);
}

// Errors from the file route are JSON {errorMessage, statusCode} (no `status` key).
function errorFromJson(data, fallback) {
	if (!data || typeof data !== 'object') return fallback;
	if (data.statusCode === 200 && !data.errorMessage) return null;
	return data.errorMessage || data.message || fallback;
}

// Upload one file to the pending area. XHR so we get progress.
// Returns a promise of {name, shown, size, kind}; promise.abort() cancels it.
function uploadFile(file, onProgress) {
	const xhr = new XMLHttpRequest();
	const promise = new Promise((resolve, reject) => {
		xhr.open('POST', CHAT_FILE);
		const headers = { ...authHeader(), ...localHeaders() };
		Object.entries(headers).forEach(([k, v]) => { if (v !== null && v !== undefined) xhr.setRequestHeader(k, v); });
		xhr.upload.onprogress = (e) => { if (e.lengthComputable && onProgress) onProgress(e.loaded / e.total); };
		xhr.onload = () => {
			let data = null;
			try { data = JSON.parse(xhr.responseText); } catch (e) { /* not JSON */ }
			const err = errorFromJson(data, 'Upload failed');
			if (err || !data?.data?.name) reject(err || 'Upload failed');
			else resolve(data.data);
		};
		xhr.onerror = () => reject('Upload failed');
		xhr.onabort = () => reject('cancelled');
		const fd = new FormData();
		fd.append('op', 'upload');
		fd.append('file', file, file.name);
		xhr.send(fd);
	});
	promise.abort = () => xhr.abort();
	return promise;
}

function fileRoute(body) {
	return fetch(CHAT_FILE, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', ...authHeader(), ...localHeaders() },
		body: JSON.stringify(body),
	});
}

// Remove a file that was uploaded but not sent yet.
function deleteUpload(name) {
	return fileRoute({ op: 'delete', name }).then((res) => res.json().catch(() => null)).then((data) => {
		const err = errorFromJson(data, 'Could not remove the file');
		if (err) return Promise.reject(err);
		return data;
	});
}

// Save a blob as a file through a hidden link.
function saveBlob(blob, filename) {
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = filename || 'download';
	a.style.display = 'none';
	document.body.appendChild(a);
	a.click();
	a.remove();
	setTimeout(() => URL.revokeObjectURL(url), 10000);
}

// Download a chat file (area 'in' = user upload, 'out' = file Claude made). shared = someone else's shared chat.
// The token goes in a header, so a plain link can't work: fetch -> blob -> <a download>.
function downloadFile(chatId, area, name, shownName, shared) {
	return fileRoute({ op: 'get', chatId, area, name, ...(shared ? { shared: true } : {}) }).then((res) => {
		const type = res.headers.get('Content-Type') || '';
		if (type.includes('application/json')) {
			return res.json().catch(() => null).then((data) => Promise.reject(errorFromJson(data, 'Download failed') || 'Download failed'));
		}
		if (!res.ok) return Promise.reject('Download failed');
		return res.blob().then((blob) => saveBlob(blob, shownName || name));
	});
}

const serverChatServices = { chatAction, uploadFile, deleteUpload, downloadFile, saveBlob };

export default serverChatServices;
